module.exports = __webpack_public_path__ + "static/media/Emma.1c837fca.png";